import React, { useState, useRef } from 'react';
import Logo from './images/blue transparent2_.png';
import Spinner from './images/load.gif';


function Loader() {
    return (
        <div
            style={{
                position: "fixed",
                inset: 0,
                backgroundColor: "white",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                gap: "8px"
            }}
        >
            <img src={Logo} width="120px" alt="Company logo" />
            <img src={Spinner} style={{ marginTop: "-10px" }} width="85px" alt="Loading" />
        </div>
    );
}

export default Loader;
